<template>
    <client-only>
        <portal to="limb" ref="portal">
            <div
                :class="classList"
                class="cases-panel elevate"
            >
                <button
                    @click="close"
                    class="panel-close btn-bg elevate"
                    :title="`${$t('general.close')} (ESC)`"
                >
                    <span class="icon-ic-dismiss"/>
                </button>

                <transition v-if="!noTitle" :name="`fade-slide-${translate}`" mode="out-in">
                    <h2 :class="`panel-title ${titleClass || ''}`">
                        {{title}} <slot name="head" />
                    </h2>
                </transition>

                <div
                    class="drawer-content"
                    v-bsl="panelVisible"
                    :id="layoutId"
                >
                    <slot v-if="panelVisible"/>
                </div>
            </div>
        </portal>
    </client-only>
</template>


<script>
// TODO: Ask before discard changes @close
import modalNavigation from '~/mixins/modalNavigation.js';

export default {
    name: 'CasesPanel',

    mixins: [modalNavigation],

    props: ['modalName', 'classes', 'side', 'defTitle', 'noTitle', 'titleClass'],

    data () {
        return {
            modalType: 'drawer',
            emiters: [],
            emiter: 'cases-panel',
            title: this.defTitle,
            translate: 'left',
            changed: false,
            panelVisible: false
        }
    },

    computed: {
        open () {
            return this.$modalityStore.drawer == this.modalName;
        },

        classList () {
            let classList = [];
            if (this.classes) classList = [...this.classes];

            classList.push(this.position);

            if (this.open) classList.push('active');
            return classList;
        },

        position () {
            return this.side || 'left';
        },

        layoutId () {
            return `${this.modalName}-panel-layout`;
        }
    },

    watch: {
        '$modalityStore.drawer': {
            immediate: true,

            handler (val, oldVal) {
                if (!val && oldVal == this.modalName) {
                    this.afterClose();
                    this.$emit("hide");
                } else if (val == this.modalName) {
                    this.$emit("show");
                }
            }
        },

        open: {
            immediate: true,

            handler (val, oldVal) {
                if (val) {
                    this.panelVisible = true;
                    // Block body scroll and recrop content
                    if (process.client) {
                        setTimeout(() => {
                            this.$cropContent();
                        }, 100);
                    }
                }
                if (!val && oldVal && process.client) {
                    // Unblock Body scroll after panel is closed
                    setTimeout(() => {
                        if (!this.open) this.panelVisible = false;
                    }, 350)
                }
            }
        }
    },

    mounted () {
        this.$root.$on('change-panel-title', this.changeTitle);
    },

    methods: {
        close () {
            this.$modalityStore.closeModal({
                type: this.modalType,
                name: this.modalName
            });
            this.afterClose();
        },

        afterClose () {
            this.emiters.forEach(el => el.classList.remove('active'))
            this.emiters = [];
            this.$emit('close')
        },

        changeTitle (data) {
            if (data.name !== this.modalName) return true;
            this.title = data.title;
        }
    },

    destroyed () {
        this.$root.$off('change-panel-title', this.changeTitle);
    }
}
</script>


<style>
.fade-slide-bottom-enter-active,
.fade-slide-top-enter-active,
.fade-slide-left-enter-active,
.fade-slide-right-enter-active {
  transition: transform .2s cubic-bezier(1.0, 0.7, 0.8, 1.0),
              opacity .2s cubic-bezier(1.0, 0.7, 0.8, 1.0);
}
.fade-slide-bottom-leave-active,
.fade-slide-top-leave-active,
.fade-slide-left-leave-active,
.fade-slide-right-leave-active {
  transition: transform .2s cubic-bezier(0.1, 0.8, 0.5, 1.0),
              opacity .2s cubic-bezier(0.1, 0.8, 0.5, 1.0);
}

.fade-slide-bottom-enter-to,
.fade-slide-bottom-leave,
.fade-slide-top-enter-to,
.fade-slide-top-leave,
.fade-slide-right-enter-to,
.fade-slide-right-leave,
.fade-slide-left-enter-to,
.fade-slide-left-leave {
    transform: translate(0, 0);
    opacity: 1;
}

.fade-slide-left-enter,
.fade-slide-left-leave-to {
    transform: translate(5px, 0);
    opacity: 0;
}

.fade-slide-right-enter,
.fade-slide-right-leave-to {
    transform: translate(-5px, 0);
    opacity: 0;
}

.fade-slide-top-enter,
.fade-slide-top-leave-to {
    transform: translate(0, 5px);
    opacity: 0;
}

.fade-slide-bottom-enter,
.fade-slide-bottom-leave-to {
    transform: translate(0, -5px);
    opacity: 0;
}

.fade-slide-left-leave-to {
    transform: translate(-5px, 0);
    opacity: 0;
}

.fade-slide-right-leave-to {
    transform: translate(5px, 0);
    opacity: 0;
}

.fade-slide-top-leave-to {
    transform: translate(0, -5px);
    opacity: 0;
}

.fade-slide-bottom-leave-to {
    transform: translate(0, -5px);
    opacity: 0;
}

</style>
